module.exports = __webpack_public_path__ + "static/media/poll-submit.45f6b35b.svg";